<template>
  <div class="pop_image">
    <avatar-cropper
        :ref="'change_image_'+item.class"
        :trigger="'#change_image_'+item.class"
        :labels="{submit: $t('status.ok'), cancel: $t('status.cancel')}"
        @update="handleUpdate"
        @changed="handleChanged"
        @submit="handleSubmit"
        @cancel="handleCancel"
        @uploading="handleUploading"
        @uploaded="handleUploaded"
        @error="handleError"
        :upload-headers="this.header"
        :upload-url="API+'/storage/upload/single'"
        :upload-form-data="{folderPath:item.folderPath === undefined ? '' : item.folderPath}"
        :output-mime="'image/jpeg'"
        :cropper-options="{
          aspectRatio: 10/12,
          viewMode: 1,
          minCropBoxWidth: 80,
          ...item.cropperOptions,
          ready : handleReady,
          cropstart : handleCropStart,
          cropmove : handleCropmove,
          cropend : handleCropend,
          crop : handleCrop,
          zoom : handleZoom,
        }"
        :output-options="item.outputOptions === undefined ? {maxWidth:550, maxHeight:660} : item.outputOptions"
    />
    <div
        :class="`set_photo_area${item.deleteBtn === true ? ' delete_btn' : ''}`"
    >
      <LoadingOverlay :activeSyncProps="activeSync" :isFullPageProps="false"/>
      <div class="set_photo_frame" v-if="item.values">
        <img :src="item.values" alt="">
      </div>
      <div class="set_photo_frame" v-else>
        <img
            v-show="item.class !== 'sign'"
            src="../../../../assets/images/img_photo_none.png"
            style="width: 60px; min-height: 76px;"
            alt=""
        />
      </div>
      <span
          v-show="item.deleteBtn === true"
          class="clearBtn"
          @click="handleClearClick"
      >
        {{ $t('status.delete') }}
      </span>
    </div>
    <span class="photo_add_btn">
       <button
           :id="'change_image_'+item.class"
           class="pointer"
           :disabled="imgLoad"
       >
         <img
             src="../../../../assets/images/img_btn_loadphoto.png"
             style="max-width: 35px;width: 34px;height: 34px;"
             alt=""
         />
       </button>
    </span>
    <Progress
        :progress="imgLoad"
    />
  </div>
</template>
<script>
import AvatarCropper from "vue-avatar-cropper"
import {_API, _ERROR_CHECK, _HEADER} from '@/static';
import LoadingOverlay from "@/components/loadingOverlay/index";
import Progress from '@/components/modal/scheduleCalendar/progress'

export default {
  components: {
    LoadingOverlay,
    AvatarCropper,
    Progress,
  },
  props: [
    'item',
  ],
  data() {
    const header = _HEADER();

    return {
      API: _API,
      activeSync: false,
      header: {
        'x-lang': header["x-lang"],
        'tz': header["tz"],
        'x-access-token': header["x-access-token"],
        'x-refresh-token': header["x-refresh-token"],
      },
      imgLoad: false,
    }
  },
  mounted() {
    // This is intentional
  },
  beforeDestroy() {
    // This is intentional
  },
  errorCaptured(err, _vm, _info) {
    try {
      // console.log('errorCaptured')
      this.imgLoad = false;

      this.$refs['change_image_' + this.item.class].$refs.input.value = '';
      this.$refs['change_image_' + this.item.class].dataUrl = undefined;

      if (String(err).toLowerCase().includes((`Invalid array length`).toLowerCase())) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'modal.imageError.big',
        });
      } else {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.retry_again',
        });
      }
    } catch (e) {
      this.$modal.show('common-alert-modal', {
        messageType: 'short',
        message: 'alert.retry_again',
      });
    }
  },
  methods: {
    handleUpdate(_value) {
      // console.log('handleUpdate', value)
    },
    handleChanged(_file, reader) {
      // console.log('handleChanged', _file, reader)

      this.imgLoad = true;
      reader.addEventListener('loadend', () => {
        this.imgLoad = false;
        document.getElementsByClassName('avatar-cropper-footer')[0].getElementsByTagName('button')[1].disabled = true;
      });
    },
    handleSubmit() {
      // console.log('handleSubmit')
      this.imgLoad = false;
    },
    handleCancel() {
      // console.log('handleCancel')
      this.imgLoad = false;
    },
    handleUploading() {
      // console.log('handleUploading')
      this.activeSync = true;
    },
    handleUploaded(resp) {
      // console.log('handleUploaded', resp)
      this.item.values = `${resp.publicPath}`;
      this.activeSync = false;
    },
    handleError(message, _type, _context) {
      // console.log('handleError', message, type, context)
      this.imgLoad = false;
      this.activeSync = false;
      if (message !== 'File type not correct.') {
        _ERROR_CHECK({
          name: 'error',
          message: message
        });
      } else {
        this.$modal.show('common-alert-modal', {
          messageType: 'lineBreak',
          message: 'alert.imgFormat',
        });
      }
    },
    handleClearClick(_e) {
      // console.log('handleClearClick', _e)
      this.item.values = '';
    },
    handleReady() {
      // console.log('handleReady', ...arguments)
      this.imgLoad = false;
      document.getElementsByClassName('avatar-cropper-footer')[0].getElementsByTagName('button')[1].disabled = false;

      this.item?.cropperOptions?.ready instanceof Function && this.item?.cropperOptions?.ready(...arguments);
    },
    handleCropStart() {
      // console.log('handleCropStart', ...arguments)
      this.item?.cropperOptions?.cropstart instanceof Function && this.item?.cropperOptions?.cropstart(...arguments);
    },
    handleCropmove() {
      // console.log('handleCropmove', ...arguments)
      this.item?.cropperOptions?.cropmove instanceof Function && this.item?.cropperOptions?.cropmove(...arguments);
    },
    handleCropend() {
      // console.log('handleCropend', ...arguments)
      this.item?.cropperOptions?.cropend instanceof Function && this.item?.cropperOptions?.cropend(...arguments);
    },
    handleCrop() {
      // console.log('handleCrop', ...arguments)
      this.item?.cropperOptions?.crop instanceof Function && this.item?.cropperOptions?.crop(...arguments);
    },
    handleZoom() {
      // console.log('handleZoom', ...arguments)
      this.item?.cropperOptions?.zoom instanceof Function && this.item?.cropperOptions?.zoom(...arguments);
    },
  },
}
</script>
<style lang="scss">
@import "@/scss/image-box.scss";

.avatar-cropper-image-container{
  min-width: 240px;
}

.pop_image {
  position: relative;
}

.set_photo_area {
  width: 110px;
  height: 130px;
  margin-right: 10px;
}

.photo_add_btn {
  display: flex;
  position: absolute;
  bottom: -7px;
  left: 81px;
}

#change_image_doctor {
  width: 35px;
  height: 35px;
  background: var(--white);
  border-radius: 50px;
  border: 1px solid var(--grey20);
  z-index: 99;
  padding: 0;
}

#change_image_doctor:focus-visible {
  outline: none;
}

#change_image_sign {
  width: 35px;
  height: 35px;
  background: var(--white);
  border-radius: 50px;
  border: 1px solid var(--grey20);
  z-index: 99;
  padding: 0;
}

#change_image_sign:focus-visible {
  outline: none;
}

.delete_btn {
  .clearBtn {
    opacity: 0;
    position: absolute;
    left: 5px;
    bottom: 5px;
    cursor: pointer;
    color: var(--grey70);
    font-size: 12px;
    font-weight: bold;
  }
}

.delete_btn:hover {
  .set_photo_frame {
    opacity: 0.3;
  }

  .clearBtn {
    opacity: 1;
  }
}
</style>